/*eslint-disable */
const responsiveEvent = (el, classes) => {
	$(el).removeClass(classes);
	let width = document.documentElement.offsetWidth || document.body.offsetWidth;
	if (width < 1000) {
		$(el).addClass(classes);
	}
};

export default {
	mounted (el, binding) {
		let classes = binding.value;
		if (!classes || classes.length === 0) {
			classes = 'app_container';
		}
		responsiveEvent(el, classes);
		window.addEventListener('resize', () => {
			responsiveEvent(el, classes);
		});
	},
	unmounted (el, binding) {
		let classes = binding.value;
		if (!classes || classes.length === 0) {
			classes = 'app_container';
		}
		window.removeEventListener('resize', () => {
			responsiveEvent(el, classes);
		});
	},
};